import React from 'react';
import { memo } from 'react';

import { LangChooserInfoNameStyled, LangChooserInfoWrapperStyled } from './styled/LangInfoStyled';

interface ILangInfoProps {
    langName: string
}
export const LangInfo = memo(({ langName }:ILangInfoProps) => (
    <LangChooserInfoWrapperStyled>
        <LangChooserInfoNameStyled>{langName}</LangChooserInfoNameStyled>
    </LangChooserInfoWrapperStyled>
))